import React from 'react';

import { ListingPageFilterBar } from '@futrli/ui-components/components/listing-page/listing-page-filter-bar/listing-page-filter-bar';
import { Role } from '@futrli-sdk/roles';

import { RoleFilter } from './components/role-filter';
import { StatusFilter } from './components/status-filter';

interface UsersListFilterBarProps {
  onRoleFilterChange: (value: string) => void;
  onSearchChange: (value: string) => void;
  onStatusFilterChange: (value: string) => void;
  roleFilterValue: string;
  roles?: Role[];
  searchTerm: string;
  statusFilterValue: string;
  stickyTop?: number;
}

export const UsersListFilterBar = ({
  onRoleFilterChange,
  onSearchChange,
  onStatusFilterChange,
  roleFilterValue,
  roles,
  searchTerm,
  statusFilterValue,
  stickyTop
}: UsersListFilterBarProps) => (
  <ListingPageFilterBar onSearchChange={onSearchChange} searchTerm={searchTerm} stickyTop={stickyTop}>
    <RoleFilter onChange={onRoleFilterChange} roles={roles} selectedValue={roleFilterValue} />
    <StatusFilter onChange={onStatusFilterChange} selectedValue={statusFilterValue} />
  </ListingPageFilterBar>
);
